<template>
  <div class="wrapper">
    <div class="content-section">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Section',
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';
@import '@/themes/default/placeholders.scss';
@import '@/themes/default/mixins.scss';

.wrapper {
  .content-section {
    flex: 10;
    border: 1px solid red;
    height: calc(100vh - 62px);
    @each $i in $directions {
      @extend %half-padding-#{$i};
    }
    @media screen and (max-width: 575px) {
      height: calc(100vh - 58.4px);
    }
    @include bg-color($gray-lighter);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/templates/section/index.vue